import { FC, useEffect } from "react";
import { apiCall, postMessengerReceivedDelivery } from "tm-shared/api";

import { useAppDispatch } from "@/hooks";
import { BaseButton, BaseModal } from "@/shared/ui";
import { SecondaryText } from "@/shared/ui/Typography";
import { setAsyncStatus } from "@/store/slices/ui";
import { ModalPayloads, ModalType } from "@/types/modals";

interface ExportPaymentProps {
    payload: ModalPayloads[ModalType.ExportPayment];
    onCloseModal: () => void;
}

export const ExportPayment: FC<ExportPaymentProps> = ({
    payload,
    onCloseModal,
}) => {
    const dispatch = useAppDispatch();

    const { desc, title, callback, deliveryId } = payload;

    useEffect(() => {
        if (deliveryId) {
            postMessengerReceivedDelivery({
                deliveryId: deliveryId,
            });
        }
    }, [deliveryId]);

    useEffect(() => {
        const callCallback = async () => {
            if (callback) {
                await apiCall({
                    method: callback.method,
                    params: {
                        ...callback.params,
                    },
                });
            }

            dispatch(
                setAsyncStatus({
                    key: "paymentExportPending",
                    value: false,
                }),
            );
        };

        callCallback();
    }, [callback, dispatch]);

    return (
        <BaseModal
            open
            title={title}
            closable={false}
            actions={null}
            onClose={onCloseModal}
        >
            <SecondaryText>{desc}</SecondaryText>

            <BaseButton onClick={onCloseModal} type="primary">
                Ок
            </BaseButton>
        </BaseModal>
    );
};
